export default [
  {
    path: '/transferencia/',
    name: 'transferencia',
    title: 'transferência',
    component: () => import('../views/TransferenciaView.vue'),
    redirect: { name: 'transferencia-listar' },
    children: [
      {
        path: 'welcome',
        name: 'transferencia-listar',
        meta: {
          title: 'Transferência',
        },
        component: () => import('../views/TransferenciaWelcomeView.vue'),
      },
      {
        path: 'add',
        name: 'transferencia-cadastrar',
        meta: {
          title: 'Transferência cadastrar',
        },
        component: () => import('../views/TransferenciaFormView.vue'),
      },
      {
        path: ':id',
        name: 'transferencia-editar',
        meta: {
          title: 'transferência editar',
        },
        component: () => import('../views/TransferenciaFormView.vue'),
      },
    ],
  },
];
